export enum RequestState {
    Idle,
    Loading,
    Success,
    Error,
}
